// *******************************************************************************
// 1.0 - Close Modal
// *******************************************************************************
document.querySelectorAll('.modal, .modal__close').forEach((modal) => {
  modal.addEventListener('click', (event) => {
    const insideContent = event.target.closest('.modal__content');
    if (event.target.closest('.modal__close') || !insideContent) {
      const modalBox = event.target.closest('.modal');
      modalBox.classList.remove('is-open-modal');
    }
  });
});
